import dd from "ES/lib/dd";
import esUtils from "ES/utils/esUtils";

require("./InitialsInput.less");

let component = dd.createClass({
	__onChange: function(e){
		this.props.onChange(e.target.value);
	},
	render(){
		let field = this.props.field;
		let value = this.props.value;

		return dd.div({className: "InitialsInput"},
			dd.div({className: "InitialsInput-group"},
				dd.div({className: "input", style: {minWidth: 200}}, field.name_full),
				"Name"
			),
			dd.div({className: "InitialsInput-group"},
				dd.div(null,
					dd.input({
						type: "text",
						name: "initials",
						value: value || "",
						disabled: field.disabled ? "disabled" : null,
						className: "form-control",
						onChange: this.__onChange
					})
				),
				dd.span({className: "help-block"}, "Initials")
			),
			dd.div({className: "InitialsInput-group"},
				dd.div({className: "input"},
					esUtils.format_date(new Date(), "m/d/yyyy")
				),
				"Date"
			),
			dd.div({className: "clearfix"})
		);
	}
});

export default {
	component: component,
	validate: function(v){
		return esUtils.isBlank(v)
			? "Please enter your initials to sign this agreement"
			: true;
	}
};



// WEBPACK FOOTER //
// ./src/components/inputs/InitialsInput.js